// 1-5 consequence/likelihood scale colours - same ramp as getRAGcolor's
// bands so individual scores and totals read consistently.
const getScoreColor = (rating) => {
  switch (rating) {
    case 1:
      return '#00964C'
    case 2:
      return '#66A63C'
    case 3:
      return '#CCA43B'
    case 4:
      return '#F28B1F'
    case 5:
      return '#E32525'
    default:
      return '#94A3B8'
  }
}

export default getScoreColor
